/**************************************************
 * Nombre:       Lista_Productos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Tarjeta_Producto from "../../Tarjetas/Tarjeta_Producto";
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";

const Lista_Productos = ({productos}) => {
    const {sCell, masSM} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>


            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: sCell ? 3 : 6, mt: 8}}
                spacing={!masSM ? 4 : 8}
            >


                {productos.map((it, index) => {
                    return (
                        <Grid container size={{xs: 6, sm: 4, md: 3}}>
                            <Tarjeta_Producto item={it}/>
                        </Grid>
                    )
                })}


            </Grid>

        </Grid>
    )

}
export default Lista_Productos
